(function () {
    'use strict';

    angular
        .module('app')
        .filter('humanSize', humanSize);

    humanSize.$inject = [];

    function humanSize() {
        return function (size) {
            size = parseInt(size, 10);
            var unit = 'B';

            if (!isFinite(size) || size < 0) {
                size = 0;
            } else if (size >= Math.pow(1024, 5)) {
                size = Math.round(size * 100 / Math.pow(1024, 5)) / 100;
                unit = 'PB';
            } else if (size >= Math.pow(1024, 4)) {
                size = Math.round(size * 100 / Math.pow(1024, 4)) / 100;
                unit = 'TB';
            } else if (size >= Math.pow(1024, 3)) {
                size = Math.round(size * 100 / Math.pow(1024, 3)) / 100;
                unit = 'GB';
            } else if (size >= Math.pow(1024, 2)) {
                size = Math.round(size * 100 / Math.pow(1024, 2)) / 100;
                unit = 'MB';
            } else if (size >= 1024) {
                size = Math.round(size * 100 / 1024) / 100;
                unit = 'kB';
            }

            return size + ' ' + unit;
        };
    }

})();